"use client";
import { useEffect, useRef, useState } from "react";
import logo from "../../images/logo.svg";

const Header = () => {
  const togglerRef = useRef<HTMLButtonElement>(null);
  const [navOpen, setNavOpen] = useState(false);

  const closeNav = () => {
    const toggler = togglerRef.current;
    if (toggler && window.getComputedStyle(toggler).display !== "none") {
      setNavOpen(false);
    }
  };

  useEffect(() => {
    const links = document.querySelectorAll("nav a");
    links.forEach((link) => link.addEventListener("click", closeNav));

    return () => {
      links.forEach((link) => link.removeEventListener("click", closeNav));
    };
  }, []);

  return (
    <header>
      <div className="container">
        <nav className="navbar navbar-expand-lg navbar-light">
          <a href="/">
            <img src={logo.src} className="logo" alt="logo" />
          </a>
          <button
            ref={togglerRef}
            className="navbar-toggler"
            type="button"
            aria-controls="navbarSupportedContent"
            aria-expanded={navOpen}
            aria-label="Toggle navigation"
            onClick={() => setNavOpen((prev) => !prev)}
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div
            className={`collapse navbar-collapse justify-content-end${navOpen ? " show" : ""}`}
            id="navbarSupportedContent"
          >
            <ul className="navbar-nav mr-auto align-items-center">
              <a className="btn" href="mailto:signowise@cursorinsight.com">
                Schedule a demo
              </a>
              <div className="dropdown">
                <button className="dropbtn">
                  Integrated Solutions
                  <i className="fa fa-caret-down"></i>
                </button>
                <div className="dropdown-content">
                  <div className="column">
                    <h5>Use Cases</h5>
                    <a href="/#use-cases">Money transfers</a>
                    <a href="/#use-cases">Retail banking use cases</a>
                    <a href="/#use-cases">Insurance in use cases</a>
                    <a href="/econtracting">E-contracting</a>
                    <a href="/#use-cases">Financing, lending & mortgages</a>
                    <a href="/#use-cases">Commercial banking use cases</a>
                    <a href="/#use-cases">Human resources</a>
                    <a href="/#use-cases">E-prescribing</a>
                  </div>
                  <div className="column">
                    <h5>Industries</h5>
                    <a href="/#industries">Financial services</a>
                    <a href="/#industries">Insurance</a>
                    <a href="/#industries">Lending and Financing</a>
                    <a href="/#industries">Retail Banking</a>
                    <a href="/#industries">Commercial Banking</a>
                    <a href="/#industries">Wealth Management</a>
                    <a href="/#industries">Government</a>
                    <a href="/#industries">Healthcare</a>
                  </div>
                </div>
              </div>
              <a href="mailto:signowise@cursorinsight.com" className="link">
                Contact
              </a>
            </ul>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
